module.exports = __webpack_public_path__ + "media/images/shopping-cart/cards-3f60552e1322908e80fa710dc4952271.png";